import { connect } from 'react-redux';
import FormBuilder from 'components/forms/FormBuilder/FormBuilder';
import setFilter from 'state/actions/setFilter';
import getFilterValues, { initialValues } from './../selectors/getFilterValues';
import debounce from 'lodash/debounce';
import { SEARCH_DEBOUNCE_DELAY } from 'consts/search';

const mapStateToProps = state => ({
  defaultValues: initialValues,
  initialValues: getFilterValues(state),
  fields: [{
    type: 'text',
    name: 'search',
    label: 'Search',
  }],
  filter: true,
  autoSubmit: true,
});

const mapDispatchToProps = dispatch => {
  const debouncedSearch = debounce((data) => {
    dispatch(setFilter(data, ['page']));
  }, SEARCH_DEBOUNCE_DELAY);

  return {
    onSubmit: (data) => {
      if (data.search !== undefined) {
        debouncedSearch(data);
      } else {
        dispatch(setFilter(data, ['page']));
      }
    },
  };
};

const countriesFilters = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FormBuilder);

export default countriesFilters;
